<template>
    <div>
        <h4><q-icon name="balance" /> Associer des droits d'auteur à l'exposition</h4>
        <q-select v-model="selectedRights" :options="rightsOptions" label="Droits d'auteur" />
        <br>
        <q-btn label="Enregistrer" color="secondary" @click="addRights" />
        <q-banner v-if="success" class="bg-secondary text-white banner">
            Droits ajoutés
        </q-banner>
    </div>
</template>
  
<script>
import { ref, onMounted } from 'vue';
import axios from 'axios';
import { useStore } from 'vuex';
export default {
    setup(props, ctx) {
        const store = useStore();
        const selectedRights = ref(null);
        let success = ref(false);
        const rightsOptions = [
            "Oeuvres pouvant être soumises à droits d'auteur",
            "Domaine public",
            "Creative Commons - Attribution (BY)",
            "Creative Commons - Partage dans les Mêmes Conditions (BY-SA)",
            "Creative Commons - Pas de Modification (BY-ND)",
            "Creative Commons - Pas d'Utilisation Commerciale(BY - NC)",
            "Creative Commons - Pas d'Utilisation Commerciale - Partage dans les Mêmes Conditions(BY - NC - SA)",
            "Creative Commons - Pas d'Utilisation Commerciale - Pas de Modification(BY - NC - ND)"
        ];
        const start = () => {
            setTimeout(() => {
                getRights();
            }, 1000);
        }

        const getRights = async () => {
            try {
                let exhibitId = store.state.exhibitId;
                let url = `${process.env.VUE_APP_BASEURL}/rights/${exhibitId}`;
                const response = await axios.get(url);
                if (response.status === 200) {
                    selectedRights.value = response.data[0].right_name;
                }
            } catch (error) {
                console.log(error);
            }
        }

        const addRights = async () => {
            try {

                let exhibitId = store.state.exhibitId;
                let url = `${process.env.VUE_APP_BASEURL}/rights`;
                const response = await axios.post(url, { exhibitId: exhibitId, rights: selectedRights.value });
                if (response.status === 200) {
                    success.value = true;
                    setTimeout(() => {
                        success.value = false;
                    }, 1500);
                    ctx.emit('rightsAdded');
                }
            } catch (error) {
                console.error('Erreur lors de l\'ajout des droits:', error);
            }
        };

        onMounted(start)

        return {
            selectedRights,
            rightsOptions,
            success,
            addRights,
        };
    },
};
</script>
<style>
.banner {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99999;

  /* Design */
  padding: 15px 30px;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  /* Typographie */
  font-size: 16px;
  font-family: 'Helvetica', sans-serif;  /* Remplacez par la police de votre choix */
  
  /* Transition */
  transition: all 0.3s ease-in-out;
}
</style>